export default __webpack_public_path__ + "static/media/info.1b4003e2.png";